export class UserDetails {
    userID: number;
    publisherID: number;
    userCode: string;
    emailID: string;
    firstName: string;
    lastName: string;
    token: string;
    userStatus: string;
    userType: string;
    role: string;
    webmartCode: string;
    webmartID: number;
    sushiStatus: number;
    Email_Alert: string;
    apikey: string;
    customerID: any;
    large_row_count : any;
}



// WEBPACK FOOTER //
// ./src/app/pages/shared/user-detail.ts